import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";

export default function LiquidationSucess(props) {
  const history = useHistory()

  const handleClick = () => {
    history.push('/portfolio')
  }
  return (
    <>
      <div className="final-sec container">
        {props.showSucess || props?.product === 'bonds' ?
          <>
            <p className="fianl-title text-center">
              Thank You</p>
            <div className="subHeading d-flex justify-content-center align-items-center">

              <span className="mb-5">
                Liquidation Order has been Placed
              </span>
            </div>
            {props?.product === "mld" ?
              <>
                <p className="fianl-title2 text-center">Now you will have to complete the transaction through your broker platform which is linked to your DEMAT account. In 3 working days (T+3 working days) you will have to place a Sell Order through their Broker at the liquidation price and units confirmed in the earlier step. This order will be accepted from 
                 our side and once the order is matched on the Stock Exchange, the units will be debited from your DEMAT account. </p>

                <p className="fianl-title2 text-center">You will receive the funds in your account as per stock exchange regulations.</p>

                <p className="fianl-title2 text-center"><b>Important Note:</b> The price of the MLD and the redemption amount is now frozen irrespective
                 of whether or not the transaction is concluded through the broker platform. If you have missed concluding the transaction at the designated date,
                  you can contact our Customer support team and we will arrange for the transaction to be concluded on another date at the same price and redemption amount.</p>

              </> :
              <>
                <p className="fianl-title2 text-center">Now you will have to complete the transaction through your broker platform which is linked to your DEMAT account. In 3 working days (T+3 working days) you will have to place a Sell Order through their Broker at the liquidation price and units confirmed in the earlier step.</p>

                <p className="fianl-title2 text-center">This order will be accepted from our side and once the order is matched on the Stock Exchange, the units will be debited from your DEMAT account.
                 You will receive the funds in your account as per stock exchange regulations. </p>

                <p className="fianl-title2 text-center"><b>Important Note:</b> The price of the Bond and the redemption amount is now frozen irrespective of whether or not the transaction is concluded through
                 the broker platform. If you have missed concluding the transaction at the designated date, you can contact our Customer support team and we will arrange for the transaction to be concluded on 
                 another date at the same price and redemption amount.</p>

              </>}
          </>
          : <>
            <p className="fianl-title text-center mb-5">
              Quote Request has been sent successfully.
            </p>
            <p className="fianl-title2 text-center w-80">You will receive a notification within 1 working day for the fresh quote and you can complete the
              liquidation process by logging in on the Bidd platform.</p>

          </>
        }
        <div className="text-center mt-5 mb-5 btn-holder">
          <Button onClick={handleClick} outline>Close</Button>
        </div>
      </div>
    </>
  );
}
